
import React, { useEffect } from "react";
import { Rnd } from "react-rnd";

const ResizeAndDragabbleNotes = ({
  defaultValue = {
    x: 150,
    y: 205,
    width: 270,
    height: 323,
  },
  minWidth = 270,
  minHeight = 323,
  children,
  aspectRatio = true,
  resize = (data) => data,
  resizeEnd,
  bounds = "window",
  onFocusValue = false,
  showAccordin,
  dimensions,
  enableResizing,
  from='',
  ...props
}) => {

  // Calculate the center position
  const centerPosition = () => {
    const x = Math.floor((window.innerWidth - defaultValue.width) / 2);
    const y = Math.floor((window.innerHeight - defaultValue.height) / 2);
    return { x, y };
  };

  const initialPositionNotes = centerPosition();

  useEffect(() => {
    resize({ width: defaultValue.width, height: defaultValue.height });
  }, []);

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }
    window.dispatchEvent(
      new CustomEvent("draggable-widget-toggle", {
        detail: { target: "notes", open: true },
      })
    );
    return () => {
      window.dispatchEvent(
        new CustomEvent("draggable-widget-toggle", {
          detail: { target: "notes", open: false },
        })
      );
    };
  }, []);

  const resizeHandleStyles = {
    top: { display: "none" },
    bottom: { display: "none" },
    left: { display: "none" },
    right: { display: "none" },
    topLeft: { display: "none" },
    topRight: { display: "none" },
    bottomLeft: { display: "none" },
    bottomRight: { display: "none" },
  };

  return (
    <Rnd
      lockAspectRatio={false}
      default={{
        x: from === 'notes' && initialPositionNotes.x,
        y: from === 'notes' && initialPositionNotes.y,
        ...defaultValue,
      }}
      minWidth={minWidth}
      minHeight={minHeight}
      bounds={bounds}
      disableDragging={onFocusValue}
      enableResizing={enableResizing || true}
      resizeHandleStyles={aspectRatio ? resizeHandleStyles : {}}
      onResize={(e, direction, ref, delta, position) => {
        resize({
          width: parseInt(ref.style.width, 10),
          height: parseInt(ref.style.height, 10),
          transform: `${Math.min(
            3,
            parseInt(ref.style.width, 10) / minWidth,
            parseInt(ref.style.height, 10) / minHeight
          )}`,
        });
      }}
      {...props}
    >
      <div style={{ width: "100%", height: "100%" }}>{children}</div>
    </Rnd>
  );
};

export default ResizeAndDragabbleNotes;


